var i = /* @__PURE__ */ ((l) => (l.fill = "fill", l.outline = "outline", l))(i || {});
export {
  i as ECheckboxBorderVariants
};
